export default {"src":"/_next/static/media/bolt_icon.3b7c9e34.svg","height":16,"width":9,"blurWidth":0,"blurHeight":0};